var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAlignCenter = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.77 15.05",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b2b2bf;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.88,2.56H17.11a.77.77,0,1,0,0-1.54H.88a.77.77,0,0,0,0,1.54Zm0,9H17.11a.77.77,0,0,0,.78-.77.76.76,0,0,0-.78-.76H.88a.76.76,0,0,0-.77.76A.76.76,0,0,0,.88,11.57Zm0,4.5h9.64a.77.77,0,1,0,0-1.53H.88a.77.77,0,1,0,0,1.53ZM17.12,5.53H.88a.77.77,0,0,0-.77.77h0a.77.77,0,0,0,.77.76H17.12a.77.77,0,0,0,.77-.76h0A.77.77,0,0,0,17.12,5.53Zm0,9H.88a.77.77,0,0,0-.77.77h0a.77.77,0,0,0,.77.76H17.12a.77.77,0,0,0,.77-.76h0A.77.77,0,0,0,17.12,14.54Z",
    transform: "translate(-0.11 -1.02)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAlignCenter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-align-center.c52177a317598c4ad5f86161a4e3ae14.svg";